export default __webpack_public_path__ + "static/open_culture-b4d2886a2d3502f5e3b5cdf69da6cc78.svg";